"use client";
import React, { useEffect, useState } from "react";
import dynamic from "next/dynamic";

import "../../marken/marken.css";

import { TopSectionMarken } from "../../marken/sections/TopSection";
import { AutoVerkaufenGrid } from "@/common/AutoVerkaufenGrid";
import { Banner } from "@/common/Banner";
import sellCarCash from "@/assets/auto-verkaufen/Rückbank-autoverkauf.avif";

import höchstenPreis from "@/assets/auto-verkaufen/Frau-verkauft-ihr-auto.webp";
import BannerImage1 from "@/assets/auto-verkaufen/AutoeinfachlosBannerBig1.avif";
import BannerImage2 from "@/assets/auto-verkaufen/AutoeinfachlosBannerBig2.avif";
import BannerImage3 from "@/assets/auto-verkaufen/AutoeinfachlosBannerBig3.avif";
import BildTextInfo from "@/components/BildTextInfo/BildTextInfo";

import { HäufigeFragen } from "@/common/HäufigeFragen";
import FAQImage from "@/assets/faq-autoverkauf-autoeinfachlos.webp";
import { fragenPickerlgutachtenTuevGuide } from "./data";

// Ratgeber SERVERSEITIG rendern (dynamic OHNE die SSR-Abschaltung, Playbook 2.6):
// die sechs "Mehr zum Thema"-Kacheln verlinken u. a. /auto-verkaufen.
const Ratgeber = dynamic(() =>
  import("@/components/Ratgeber/Ratgeber").then((m) => m.default)
);

// Only needed when the user reaches step 12; avoid loading auth-related JS/CSS on initial paint.
const AnmeldenSection = dynamic(() => import("@/app/anmelden/AnmeldenStepRedirect"), {
  ssr: false,
});

function PickerlgutachtenTuevGuide() {
  const [step, setStep] = useState(1);
  // selected values
  const [selectedBrand, setSelectedBrand] = useState({ id: "", name: "" });
  const [selectedModel, setSelectedModel] = useState({ id: "", name: "" });
  const [selectedYear, setSelectedYear] = useState({ id: "", name: "" });
  const [selectedBauform, setSelectedBauform] = useState({ id: "", name: "" });
  const [selectedFuel, setSelectedFuel] = useState({ id: "", name: "" });
  const [selectedVariant, setSelectedVariant] = useState({ id: "", name: "" });
  const [selectedPs, setSelectedPs] = useState({ id: "", name: "" });
  const [selectedTransmission, setSelectedTransmission] = useState({
    id: "",
    name: "",
  });
  const [selectedDoors, setSelectedDoors] = useState({ id: "", name: "" });
  const [selectedModelType, setSelectedModelType] = useState({
    id: "",
    name: "",
  });
  const [selectedKmStand, setSelectedKmStand] = useState("");
  const isSecondaryMethod = true;

  useEffect(() => {
    if (step >= 10) {
      if (typeof AnmeldenSection?.preload === "function") {
        AnmeldenSection.preload();
      } else {
        import("@/app/anmelden/AnmeldenStepRedirect");
      }
    }
  }, [step]);


  return (
    <div className="home-container">
      <TopSectionMarken
        title="Pickerlgutachten & TÜV Guide Österreich - dein umfassender Ratgeber"
        link="/guides/pickerlgutachten-tuev-guide"
        linkname="Pickerlgutachten & TÜV Guide"
        text={
          <>
            84% der Autoeinfachlos-Kunden bekommen mehr Geld.*{" "}
            <br className="desktop" />
            Hol dir deine kostenlose und sofortige Bewertung.
          </>
        }
        removePadding={true}
        step={step}
        setStep={setStep}
        selectedBrand={selectedBrand}
        setSelectedBrand={setSelectedBrand}
        selectedModel={selectedModel}
        setSelectedModel={setSelectedModel}
        selectedYear={selectedYear}
        setSelectedYear={setSelectedYear}
        selectedBauform={selectedBauform}
        setSelectedBauform={setSelectedBauform}
        selectedFuel={selectedFuel}
        setSelectedFuel={setSelectedFuel}
        selectedVariant={selectedVariant}
        setSelectedVariant={setSelectedVariant}
        selectedPs={selectedPs}
        setSelectedPs={setSelectedPs}
        selectedTransmission={selectedTransmission}
        setSelectedTransmission={setSelectedTransmission}
        selectedDoors={selectedDoors}
        setSelectedDoors={setSelectedDoors}
        setSelectedModelType={setSelectedModelType}
        selectedModelType={selectedModelType}
        selectedKmStand={selectedKmStand}
        setSelectedKmStand={setSelectedKmStand}
      />

      {step === 12 && (
        <>
          <AnmeldenSection
            title="Bitte gib deine E-Mail-Adresse ein, um fortzufahren"
            fin={null}
            isManual={isSecondaryMethod}
            marke={selectedBrand}
            model={selectedModel}
            baujahr={selectedYear}
            bodytype={selectedBauform}
            fueltype={selectedFuel}
            variant={selectedVariant}
            ps={selectedPs}
            gearbox={selectedTransmission}
            doors={selectedDoors}
            modelType={selectedModelType}
            kmStand={selectedKmStand}
            page="/auto-verkaufen"
          />
          <Banner removeContent className="Banner-anmelden" />
        </>
      )}

      {step !== 12 && (
        <div className="Page background-color">
          <div className="Page-wrapper">
            <AutoVerkaufenGrid
              image={sellCarCash}
              leftTitle="Was ist ein Pickerlgutachten?"
              leftText={
                <>
                  <p>
                    In Österreich darf ein Fahrzeug nur im Straßenverkehr bewegt
                    werden, wenn es regelmäßig der gesetzlich vorgeschriebenen
                    § 57a‑Begutachtung unterzogen wird – umgangssprachlich das
                    „Pickerl“. Diese Untersuchung stellt sicher, dass das Auto
                    technisch in Ordnung ist und die Umweltvorschriften einhält.
                    Der folgende Leitfaden beleuchtet die 3‑2‑1‑Regel, erklärt
                    die Prüfpunkte, gibt Tipps zur Vorbereitung und zeigt, was
                    du tun kannst, wenn dein Auto die Prüfung nicht besteht.
                  </p>
                </>
              }
              rightFirstTitle="Die 3‑2‑1‑Regel und Toleranzfristen"
              rightFirstText={
                <>
                  <p>Die § 57a‑Begutachtung ist zeitlich genau geregelt:</p>
                  <ul className="custom-unordered-list">
                    <li>
                      <strong>3 Jahre:</strong> Die erste Untersuchung ist drei
                      Jahre nach der Erstzulassung fällig.
                    </li>
                    <li>
                      <strong>2 Jahre:</strong> Die zweite Untersuchung folgt
                      zwei Jahre nach der ersten.
                    </li>
                    <li>
                      <strong>1 Jahr:</strong> Ab dem fünften Jahr muss das Auto
                      jährlich geprüft werden.
                    </li>
                  </ul>

                  <p>
                    Zusätzlich gibt es eine Toleranzfrist: Die Prüfung darf
                    einen Monat vor dem Fälligkeitstermin und bis zu vier Monate
                    nach dem Monat der Erstzulassung durchgeführt werden, ohne
                    dass die Plakette ihre Gültigkeit verliert.
                  </p>
                  <p>
                    <strong>Beispiel:</strong> Wurde das Auto im Mai zugelassen,
                    kann die Untersuchung zwischen April und Ende September
                    gemacht werden.
                  </p>
                </>
              }
              rightSecondTitle="Was wird geprüft?"
              rightSecondText={
                <>
                  <p>
                    Die Begutachtung umfasst zahlreiche Sicherheits- und
                    Umweltaspekte, darunter:
                  </p>

                  <ul className="custom-unordered-list secondary">
                    <li>
                      <strong>Fahrgestell und Rahmen:</strong> Kontrolle auf
                      Risse und Rost.
                    </li>
                    <li>
                      <strong>Bremsanlage:</strong> Prüfung von Bremskraft,
                      Leitungen, Scheiben und Belägen.
                    </li>
                    <li>
                      <strong>Lenkung:</strong> Funktionsfähigkeit und Spiel.
                    </li>
                    <li>
                      <strong>Fahrwerk:</strong> Aufhängung, Achsen,
                      Stoßdämpfer.
                    </li>
                    <li>
                      <strong>Beleuchtung:</strong> Scheinwerfer, Blinker,
                      Bremslichter, Nebelscheinwerfer.
                    </li>
                    <li>
                      <strong>Reifen und Räder:</strong> Profiltiefe,
                      Beschädigungen, passende Dimension.
                    </li>
                    <li>
                      <strong>Scheiben und Spiegel:</strong> Sichtbarkeit,
                      Schäden.
                    </li>
                    <li>
                      <strong>Sicherheitsgurte und Airbags:</strong>
                      Funktionstüchtigkeit.
                    </li>
                    <li>
                      <strong>Abgasanlage:</strong> Dichtigkeit und Einhaltung
                      der Emissionswerte.
                    </li>
                    <li>
                      <strong>Elektrische Systeme:</strong> Batterie, Kabel,
                      Kontrollleuchten.
                    </li>
                    <li>
                      <strong>Identifikation:</strong> Fahrgestellnummer,
                      Typenschild, Plakette.
                    </li>
                  </ul>

                  <p>
                    Die Prüfstellen dürfen keine Reparaturen während der
                    Begutachtung durchführen, um Interessenkonflikte zu
                    vermeiden. Sie dokumentieren festgestellte Mängel in einem
                    Protokoll.
                  </p>

                  <h3>Mängelkategorien</h3>
                  <ul className="custom-unordered-list secondary">
                    <li>
                      <strong>Ohne Mängel:</strong> Das Fahrzeug bekommt eine
                      gültige Plakette.
                    </li>
                    <li>
                      <strong>Leichte Mängel:</strong> Die Plakette wird
                      erteilt, aber Mängel sollten zeitnah behoben werden.
                    </li>
                    <li>
                      <strong>Schwere Mängel:</strong> Die Plakette wird unter
                      Vorbehalt erteilt. Mängel müssen innerhalb einer Frist (in
                      der Regel vier Wochen und maximal 1 000 km) behoben
                      werden.
                    </li>
                    <li>
                      <strong>Gefahr in Verzug:</strong> Schwerwiegende Defekte
                      (z. B. Rahmenbruch) führen zur sofortigen Stilllegung. Das
                      Auto darf nicht mehr gefahren werden.
                    </li>
                  </ul>
                </>
              }
            />

            <div className="Banner-sections">
              <BildTextInfo
                image={BannerImage1}
                revert
                h2
                isBig
                fontSize="36px"
                title="Vorbereitung auf das Pickerl"
                alt="Vorbereitung auf das Pickerl"
                text={
                  <>
                    <ul className="custom-unordered-list">
                      <li>
                        <strong>Vorab-Check:</strong> Lass dein Auto vor der
                        Prüfung in der Werkstatt deines Vertrauens durchsehen.
                        Kleine Reparaturen wie Bremsbeläge, Auspuffdichtungen
                        oder neue Wischerblätter lassen sich oft günstig
                        erledigen.
                      </li>
                      <li>
                        <strong>Reifen prüfen:</strong> Profiltiefe (mindestens
                        1,6 mm), Reifendruck und Beschädigungen kontrollieren.
                        Winter- und Sommerreifen sollten den Vorschriften
                        entsprechen.
                      </li>
                      <li>
                        <strong>Licht einstellen:</strong> Defekte Glühbirnen
                        ersetzen und Scheinwerfer ausrichten lassen.
                      </li>
                      <li>
                        <strong>Bremsanlage checken:</strong> Bremsscheiben,
                        -beläge und -flüssigkeit überprüfen.
                      </li>
                      <li>
                        <strong>Sauberkeit:</strong> Ein gepflegtes Auto
                        hinterlässt einen besseren Eindruck. Entferne lose
                        Gegenstände aus dem Innenraum.
                      </li>
                    </ul>
                  </>
                }
              />

              <BildTextInfo
                image={BannerImage2}
                isBig
                fontSize="36px"
                title="Ablauf der Prüfung"
                alt="Ablauf der Pickerl-Prüfung"
                text={
                  <>
                    <ul className="custom-unordered-list">
                      <li>
                        <strong>Anmeldung bei der Prüfstelle:</strong> Bringe
                        Zulassungsschein und – wenn nötig – weitere Unterlagen
                        wie COC-Papiere mit.
                      </li>
                      <li>
                        <strong>Technische Prüfung:</strong> Der Prüfer
                        kontrolliert das Fahrzeug anhand der vorgeschriebenen
                        Checkliste.
                      </li>
                      <li>
                        <strong>Protokoll:</strong> Im Anschluss erhältst du ein
                        Prüfprotokoll. Besteht dein Fahrzeug, bekommst du eine
                        neue Plakette am Kennzeichen. Bei Mängeln werden diese
                        klassifiziert.
                      </li>
                      <li>
                        <strong>Mängelbehebung:</strong> Behebe die Mängel
                        fristgerecht. Nachbesserungen dürfen meist in einer
                        Werkstatt deiner Wahl stattfinden.
                      </li>
                      <li>
                        <strong>Nachprüfung:</strong> Bei schweren Mängeln musst
                        du das Fahrzeug innerhalb der Frist erneut in derselben
                        Prüfstelle vorführen. Nur die beanstandeten Teile werden
                        kontrolliert. Überschreitest du die Frist, musst du den
                        gesamten Prüfzyklus wiederholen.
                      </li>
                    </ul>
                  </>
                }
              />

              <BildTextInfo
                image={BannerImage3}
                revert
                isBig
                fontSize="36px"
                title="Sonderregeln und Ausnahmen"
                alt="Sonderregeln und Ausnahmen beim Pickerl"
                text={
                  <>
                    <ul className="custom-unordered-list">
                      <li>
                        <strong>Oldtimer:</strong> Für historische Fahrzeuge
                        gibt es besondere Begutachtungsintervalle.
                      </li>
                      <li>
                        <strong>Anhänger und Wohnmobile:</strong> Andere
                        Intervalle und zusätzliche Prüfpunkte können gelten.
                      </li>
                      <li>
                        <strong>Importfahrzeuge:</strong> Zusätzliche Dokumente
                        wie Einfuhrabgaben, Zollpapiere und individuelle
                        Typengenehmigungen sind erforderlich.
                      </li>
                      <li>
                        <strong>Sonderfahrzeuge:</strong> Taxis, Mietwagen,
                        Fahrschulautos und Lkw werden in kürzeren Intervallen
                        geprüft.
                      </li>
                    </ul>
                  </>
                }
              />

              <BildTextInfo
                image={BannerImage1}
                h2
                isBig
                fontSize="36px"
                title="Tipps bei einem negativen Gutachten"
                alt="Tipps bei einem negativen Pickerl-Gutachten"
                text={
                  <>
                    <ul className="custom-unordered-list">
                      <li>
                        Lese das Protokoll genau und hake nach, wenn dir etwas
                        unklar ist.
                      </li>
                      <li>
                        Wähle eine Werkstatt, die Erfahrung mit § 57a‑Mängeln
                        hat.
                      </li>
                      <li>
                        Bewahre alle Rechnungen und Ersatzteilbelege auf, um
                        nachzuweisen, dass die Mängel behoben wurden.
                      </li>
                      <li>
                        Halte die Nachprüffrist unbedingt ein, um Zusatzkosten
                        zu vermeiden.
                      </li>
                    </ul>
                  </>
                }
              />
            </div>

            <HäufigeFragen
              title="Häufig gestellte Fragen"
              fragen={fragenPickerlgutachtenTuevGuide}
              image={FAQImage}
            />

            <div style={{ paddingTop: "120px" }}>
              <Ratgeber
                title="Mehr zum Thema Pickerl Gutachten"
                kaputtesAuto
                unfallAuto
                autoExport
                autoBewerten
                autoVerkaufen
                listenpreisBerechnen
              />
            </div>

            <div className="Banner-sections-marken">
              <BildTextInfo
                image={höchstenPreis}
                h2
                fontSize="36px"
                title="Fazit zum Thema Pickerl Gutachten"
                alt="Frau sitzt in einem Auto und nutzt ihr Smartphone, um mit Autoeinfachlos ihr Auto zu verkaufen."
                text={
                  <>
                    <p>
                      Die § 57a‑Begutachtung ist mehr als eine Formalie – sie
                      dient deiner Sicherheit und der Umwelt. Eine gute
                      Vorbereitung spart Zeit und Kosten. Bei kleineren Mängeln
                      erhältst du die Plakette dennoch, musst aber bald handeln.
                      Wer sein Auto regelmäßig wartet, braucht die Prüfung nicht
                      zu fürchten. Für den Verkauf ist ein aktuelles Pickerl ein
                      starkes Argument und steigert den Wert des Fahrzeugs. Mit
                      Autoeinfachlos kannst du den Verkauf nach bestandenem TÜV
                      schnell und unkompliziert abwickeln.
                    </p>
                  </>
                }
              />
            </div>
          </div>
          <Banner
            link="/auto-verkaufen"
            title="Jetzt Auto kostenlos bewerten & sicher verkaufen"
          />
        </div>
      )}
    </div>
  );
}

export default PickerlgutachtenTuevGuide;
